"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARI_ENTITLEMENT_PREFIX = exports.ECC_FORWARD_PREFIX = void 0;
exports.ECC_FORWARD_PREFIX = '/css-xp-ecc';
exports.ARI_ENTITLEMENT_PREFIX = 'ari:cloud:commerce::entitlement/';
